(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elya-home-content"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if (window.__elyaHomeInit) return;
    window.__elyaHomeInit = true;

    function initCarousels() {
      var carousels = document.querySelectorAll('[data-elya-home-carousel]');
      if (!carousels.length) return;
      Array.prototype.forEach.call(carousels, function(carousel) {
        var wrapper = carousel.closest('.elya-home-carousel-wrapper');
        var bar = wrapper ? wrapper.querySelector('[data-elya-home-scrollbar]') : null;
        var thumb = wrapper ? wrapper.querySelector('[data-elya-home-thumb]') : null;
        if (!bar || !thumb) return;

        function update() {
          var scrollWidth = carousel.scrollWidth;
          var clientWidth = carousel.clientWidth;
          var maxScroll = scrollWidth - clientWidth;
          if (maxScroll <= 1) { bar.style.display = 'none'; return; }
          bar.style.display = '';
          var w = Math.max((clientWidth / scrollWidth) * 100, 12);
          var l = (carousel.scrollLeft / maxScroll) * (100 - w);
          thumb.style.width = w + '%';
          thumb.style.left = l + '%';
        }
        carousel.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);

        var dragging = false, startX = 0, startScroll = 0;
        thumb.addEventListener('mousedown', function(e) {
          dragging = true; startX = e.clientX; startScroll = carousel.scrollLeft;
          e.preventDefault();
        });
        document.addEventListener('mousemove', function(e) {
          if (!dragging) return;
          var rect = bar.getBoundingClientRect();
          var maxScroll = carousel.scrollWidth - carousel.clientWidth;
          carousel.scrollLeft = startScroll + (e.clientX - startX) * (maxScroll / rect.width);
        });
        document.addEventListener('mouseup', function() { dragging = false; });

        bar.addEventListener('click', function(e) {
          if (e.target === thumb) return;
          var rect = bar.getBoundingClientRect();
          var pct = (e.clientX - rect.left) / rect.width;
          var maxScroll = carousel.scrollWidth - carousel.clientWidth;
          carousel.scrollTo({ left: maxScroll * pct, behavior: 'smooth' });
        });

        update();
        setTimeout(update, 300);
        setTimeout(update, 1000);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCarousels);
    else initCarousels();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
